module.exports = __webpack_public_path__ + "media/images/saiba_mais02-55fac1c0a0b69dded905301c3ea5c6ba.png";